import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagFilledSvg from "@ant-design/icons-svg/es/asn/TagFilled";
import AntdIcon from '../components/AntdIcon';
var TagFilled = function TagFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: TagFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(TagFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'TagFilled';
}
export default RefIcon;